// The chip a map shows while it's narrowed to one match dragged in from Matches ("Match: vs
// Arsenal · 14 Oct"), with ✕ back to the whole season (Ben, 2026-10-18; live/event-focus.ts).

import { setModuleFocus, type EventFocus } from "../live/event-focus.js";
import { canvasApi } from "../canvas/shell-actions.js";
import { undoApi } from "../canvas/undo.js";

/** `inline`: just the chip, for the filter chips' row (Ben, 2026-10-20: not on a row of its own);
 *  otherwise in its own row (the empty-state message's). */
export function FocusChip({ mod, focus, inline = false }: { mod: HTMLElement; focus: EventFocus; inline?: boolean }) {
  const chip = (
    <span className="filter-chip focus-chip" title={focus.kind === "zone" ? "Dragged in from a Pass Map" : focus.kind === "passes" ? "Dragged in from a Passing Report" : "Dragged in from the Matches module"}>
      <span className="chip-value">
        {focus.kind === "position" ? "Position" : focus.kind === "season" ? "Season" : focus.kind === "zone" ? "Passes from" : focus.kind === "passes" ? "Only" : "Match"}: {focus.label}
      </span>
      <span
        className="remove"
        title="Back to the whole season"
        onClick={() => {
          undoApi().saveState();
          setModuleFocus(mod, null);
          canvasApi().refreshModuleBody(mod);
        }}
      >
        ✕
      </span>
    </span>
  );
  return inline ? chip : <div className="focus-chip-row">{chip}</div>;
}
